import type { IAdminInvitationRepository } from "@/application/ports/repositories";
import type { AdminInvitation, InvitationCreateRequest } from "@/domain/admin";
import type { OrganizationRole } from "../generated/types.gen";
import * as sdk from "../generated/sdk.gen";
import { unwrap } from "../unwrap";

export class AdminInvitationRepository implements IAdminInvitationRepository {
  async createInvitation(data: InvitationCreateRequest): Promise<AdminInvitation> {
    // UI still offers legacy role values; the backend enum validates (422 on invalid)
    return unwrap(
      sdk.adminCreateInvitation({ body: { ...data, role: data.role as OrganizationRole } }),
    );
  }
  async resendInvitation(uuid: string): Promise<AdminInvitation> {
    return unwrap(sdk.adminResendInvitation({ path: { invitation_uuid: uuid } }));
  }
  async cancelInvitation(uuid: string): Promise<void> {
    await unwrap(sdk.adminDeleteInvitation({ path: { invitation_uuid: uuid } }));
  }
}
